export const getClient = (event: TouchEvent) => {
  // @ts-ignore
  const { clientX, clientY } = event.changedTouches
    ? event.changedTouches[0]
    : event;
  return [clientX, clientY];
};
